import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
const BookACall = () => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        mt: 4,
        background:
          "radial-gradient(50% 50% at 50% 50%,rgba(106,0,255,.3) 0,rgba(54,0,130,.3) 83.33%),#000",
        borderRadius: "15px",
        borderTop: "5px solid #da00c8",
        padding: "25px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "70%",
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "#fff",
            // paddingRight: "60px",
            textAlign: "center",
          }}
          //   component="div"
        >
          Add-on:{" "}
          <span
            style={{
              color: "#9bcd3d",
              textDecoration: "underline",
            }}
          >
            {" "}
            Consulting package
          </span>{" "}
          for $200
        </Typography>
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: "bold",
            color: "#fff",
            textAlign: "center",
          }}
          //   component="P"
        >
          Get a package of 5 individual meetings with Tom Winter,
          <br />
          focusing on SEO tactics, discovering quick wins, and creating a
          content calendar.
        </Typography>
      </Box>
      <Button
        onClick={() =>
          window.open(
            "https://calendly.com/tomwinter/seowind-consulting",
            "_blank"
          )
        }
        sx={{
          color: "#fff",
          background: "linear-gradient(to bottom right,#9800e9,#6a00ff)",
          padding: "0.5em 1em",
          //   marginTop: "10px",
          fontWeight: "400",
          fontSize: "0.9rem",
          borderRadius: "5px",
          textDecoration: "none",
          // Add hover effect
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            background: "#350080",
          },
        }}
      >
        Let's talk
      </Button>
    </Box>
  );
};
export default BookACall;
